<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Contents</p>
<p class="toc1"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter1">1. The Storm Clouds Gather</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2. The Storm Breaks in Murfreesboro</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. A Bold Flash of Lightning</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. A Southern Wind Before Winter</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5. Stormy Weather</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6. After the Storm</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix. Famous Civil War Figures from Murfreesboro</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1c5fc607